module.exports = __webpack_public_path__ + "img/DW365-093.d25fd8db.jpg";